const Lang = require('lang');

exports.init = function CurrencySelector() {
  const $moedasOptions = $('#moedasOptions');
  const $selector = $('#idMoedas');
  if ($selector.length) {
    $selector.selectize({
      options: JSON.parse($moedasOptions.val()),
      create: false,
      selectOnTab: true,
      maxItems: null,
      hideSelected: true,
      placeholder: Lang.get('js/src/functions/CurrencySelector.search_currencies'),
      searchField: ['codigo_iso', 'nome', 'simbolo'],
      labelField: 'nome',
      valueField: 'id'
    });
  }
}
